(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxury-clients-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.prvReady) return;
      var track = root.querySelector('[data-prv-track]');
      if (!track) return;
      root.dataset.prvReady = 'true';

      var prev = root.querySelector('[data-prv-prev]');
      var next = root.querySelector('[data-prv-next]');

      function move(direction) {
        var card = track.querySelector('.prv__card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var amount = (card ? card.getBoundingClientRect().width : track.clientWidth) + gap;
        var max = track.scrollWidth - track.clientWidth;
        var target = track.scrollLeft + direction * amount;
        if (direction > 0 && track.scrollLeft >= max - 4) target = 0;
        if (direction < 0 && track.scrollLeft <= 4) target = max;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-prv]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
